import { render, staticRenderFns } from "./AnimatedNumbers.vue?vue&type=template&id=95c471d4&scoped=true&"
import script from "./AnimatedNumbers.vue?vue&type=script&lang=js&"
export * from "./AnimatedNumbers.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedNumbers.vue?vue&type=style&index=0&id=95c471d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c471d4",
  null
  
)

export default component.exports